module.exports = __webpack_public_path__ + "img/login_left_bg@2x.a182cb6a.png";